import axios from "axios";
import type { Unit } from "@/pages/management/technicalsheets/technicalsheet/services/dto/Unit.ts";

interface ApiResponse {
  body: {
    unites: Unit[];
  };
}

export async function getUnits(domainId: string): Promise<Unit[]> {
  const response = await axios.get<ApiResponse>(
    `/rest/reference/list/${domainId}/unites`,
  );
  return response.data.body.unites;
}
